import React from 'react';
import { compose } from 'redux';

import { Dashboard } from './Dashboard';
import { DashboardProps } from './Dashboard.types';

export const DashboardContainer = compose()((props: DashboardProps) => {
  return <Dashboard {...props} />;
});
